import { Link as RouterLink } from 'react-router-dom';
import { Alert, Box, Button, Card, CardContent, CircularProgress, Stack, Typography } from '@mui/material';
import { useMiGrupoFamiliar } from '../hooks/useMisDatos';
import { formatDate } from '../utils/format';

export default function GrupoFamiliar() {
  const { data, isLoading, error } = useMiGrupoFamiliar();
  const familiares = data ?? [];

  return (
    <Stack spacing={2}>
      <Stack direction="row" justifyContent="space-between" alignItems="center" flexWrap="wrap" gap={1}>
        <Typography variant="h5" fontWeight={700}>
          Mi grupo familiar
        </Typography>
        <Button variant="contained" component={RouterLink} to="/tramites/nuevo?tipo=alta_familiar">
          Solicitar alta
        </Button>
      </Stack>
      {isLoading && <CircularProgress size={28} />}
      {error && <Alert severity="error">No pudimos cargar tu grupo familiar.</Alert>}
      {!isLoading && !error && familiares.length === 0 && <Alert severity="info">No tenés familiares cargados.</Alert>}
      <Box sx={{ display: 'grid', gap: 2, gridTemplateColumns: { xs: '1fr', sm: 'repeat(auto-fill, minmax(260px, 1fr))' } }}>
        {familiares.map((f) => (
          <Card key={f.id}>
            <CardContent>
              <Typography variant="h6">
                {f.nombre} {f.apellido}
              </Typography>
              <Typography color="text.secondary" sx={{ textTransform: 'capitalize' }}>
                {(f.parentesco ?? '').toLowerCase()}
              </Typography>
              <Box component="dl" sx={{ m: 0, mt: 1.5, display: 'grid', gridTemplateColumns: 'max-content 1fr', gap: 0.5, columnGap: 2 }}>
                <Typography component="dt" color="text.secondary">
                  Documento
                </Typography>
                <Typography component="dd" fontWeight={600} sx={{ m: 0 }}>
                  {f.dni || '-'}
                </Typography>
                <Typography component="dt" color="text.secondary">
                  Nacimiento
                </Typography>
                <Typography component="dd" fontWeight={600} sx={{ m: 0 }}>
                  {formatDate(f.fecha_nacimiento)}
                </Typography>
                {f.obra_social && (
                  <>
                    <Typography component="dt" color="text.secondary">
                      Obra social
                    </Typography>
                    <Typography component="dd" fontWeight={600} sx={{ m: 0 }}>
                      {f.obra_social}
                    </Typography>
                  </>
                )}
              </Box>
            </CardContent>
          </Card>
        ))}
      </Box>
      <Typography variant="body2" color="text.secondary">
        Para corregir un dato de un familiar, iniciá un trámite de «Corrección de datos personales».
      </Typography>
    </Stack>
  );
}
